module.exports = __webpack_public_path__ + "img/grey-arrow.305c29ee.svg";